import { graphql } from '@/gql';
import type { CreatePartnerMutation, CreatePartnerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type CreatePartnerInput = CreatePartnerMutationVariables['data'];

export type CreatePartnerOutput = CreatePartnerMutation['createPartner'];

export const createPartner = async (data: CreatePartnerInput): Promise<CreatePartnerOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreatePartner($data: PartnerInputType!) {
        createPartner(data: $data) {
          id
          name
          codeName
          callCenterNumber
          gogoNumber
          extension
          phoneNumber
          email
          streetAddress
          streetAddress2
          city
          state
          country
          zip
          latitude
          longitude
          timeZone
          website
          stripeCustomerId
          subsidyType
          subsidyAmt
          membersFlatFee
          maxSubsidyAmt
          credits
          creditsAmtMin
          creditsRenewedAt
          creditsRenewNum
          creditsRenewNumType
          maxRides
          maxRidesRenewedAt
          maxRidesRenewNum
          maxRidesRenewNumType
          subsidyCondition
          rideType
          description
          infoForDriver
          infoForOperator
          contactFirstName
          contactLastName
          contactPhoneNumber
          contactEmail
          websiteRegistration
          websiteDashboard
          numberOfRides
          notes
          isDisabled
          isAutoConfirmSurge
          ridePaymentTier
          specialRequestTier
          pharmacyPaymentTier
          gourmetPaymentTier
          groceryPaymentTier
          operatorOrderedRidePrice
          subsidyDescription
          subsidyLocations
          isIncludeInMoveUserIntoPartnershipForm
          isHideRegistrationLink
          isSendRenewalNotification
          turnOnRideOrderingLPAlert
          isRecordAllCalls
          isRollsOverMaxRides
          isNotChargeForCancellationFees
          isNotCountCanceledRides
          isEmailReceipt
          isPartnerWantEmailReceiptToMemberEvenIf100PercentSubsidy
          scheduledRideConfirmedEmail
          scheduledRideReminderDayBeforeEmail
          membershipType
          membershipAmount
          isSendWelcomeKits
          isShowUserPersonalRidesOnPartnerDashboard
          maxCallers
          plan
          transactionalSms
          noMail
          marketingMail
          isAlwaysOperator
          allowCallersVoipPhoneNumbers
          welcomeMessageUrl
          logoUrl
          collectCc
          users {
            id
            firstName
            lastName
            email
            highestRole
            isActive
          }
          serviceCode
          newSubsidy
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data!.createPartner;
};
